import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-ask-permissions',
    templateUrl: './ask-permissions.component.html',
    styleUrls: ['./ask-permissions.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AskPermissionsComponent{
  data = inject(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<AskPermissionsComponent>>(MatDialogRef);


  location;
  notification;

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() { }

  apply() {
    this.dialogRef.close({
      location: this.location,
      notification: this.notification
    });
  }
}
